import React, {Fragment} from 'react';
import {Form, Edit, Date, List, Breadcrumbs, Layout, Submit, Button, Flex} from 'components';
import {useParams, useSearchParams, useSelector, useFormRef, redirect} from 'helpers';
import {goals} from 'store';
import {Goal} from 'types';
import {GoalsDropdown} from './goals-dropdown';

export function WeeklyObjectiveEdit() {
  const params: Record<string, string> = {
    category: 'other',
    ...useParams(),
    ...useSearchParams(),
  }
  const form = useFormRef<Partial<Goal>>();
  const {goal, activities, editable} = useSelector((state) => goals.details(state, {id: params.id, context: 'goals'}));

  const initialValues = {
    parent_id: goal?.parent_id,
    name: goal?.name,
    note: goal?.note,
    target_date: goal?.target_date,
    activities: goal ? activities : [],
    ...goal,
  }

  const save = (goal: Partial<Goal>) => {
    goal.isWeeklyObjective = true;
    const {goal: {id}} = goals.dispatch.upsert({
      ...goal,
    });
    redirect(`/today/plan-my-week/start/`, true);
  }

  const change = (goal: Partial<Goal>) => {
    goals.dispatch.upsert({
      ...goal,
    });
  }

  return (
    <Form id="weeklyObjectiveForm" initialValues={initialValues} onSubmit={save} onChange={change} delay
          innerRef={form}>
      {({values}) => (
        <Fragment>
          <Layout.Header>
            <Flex>
              <div className="pull-left">
                <Breadcrumbs>
                  <b>Edit Weekly Objective</b>
                </Breadcrumbs>
              </div>
              <Button to="/today/plan-my-week/start" className={['small', 'borderless']} icon="return">
                Back
              </Button>
              <Submit className="small" icon={!goal && 'arrow-right'}>
                {['Save']}
              </Submit>
            </Flex>
          </Layout.Header>
          <div>
            <List small-gutter>
              <Edit
                bold
                name="name"
                placeholder="Enter weekly objective name.."
                required
              />
              <Edit
                name="note"
                placeholder="Enter note.."
              />
              <Date
                name="target_date"
                label="Target Date"
                minDate={values.starting_date}
                required
              />
              <GoalsDropdown
                name="parent_id"
              />
            </List>
          </div>
        </Fragment>
      )}
    </Form>
  );
}
